import React, { useEffect } from 'react';
import { gql } from '@apollo/client';
import LocalizedLink from '../../LocalizedLink';
import Loader from '../../Loader/Loader';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Navigation, Pagination } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import { useQuery } from '@apollo/client/react';

const GET_TRENDING_BRANDS = gql`
  query TrendingBrands {
    trendingBrands {
      id
      title
      slug
      logoUrl
    }
  }
`;

type TrendingBrandItem = {
  id: string;
  title: string;
  slug: string;
  logoUrl: string;
};

export default function Brands() {
  const { loading, error, data } = useQuery<{
    trendingBrands: TrendingBrandItem[];
  }>(GET_TRENDING_BRANDS);
  const urlParams = new URLSearchParams();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  if (loading) {
    return (
      <div className="flex justify-center m-4">
        <Loader />
      </div>
    );
  }

  if (error) {
    return null;
  }

  return (
    <div className="mb-16 xl:mb-28 mt-16 xl:mt-18">
      <div className="flex flex-wrap lg:flex-nowrap justify-between items-center mb-2 gap-y-4">
        <>
          <h3 className="text-2xl leading-10 font-axi-bold">Brändid</h3>
          <LocalizedLink
            className="flex items-center justify-center whitespace-nowrap font-axi-book text-sm rounded-4xl py-2.5 px-7 hover:shadow-2xl w-fit text-white bg-black hover:bg-rgrey-darker transition-all duration-100"
            to={'/brandid'}
            onClick={scrollToTop}
          >
            Vaata kõiki
          </LocalizedLink>
        </>
      </div>
      <div className="relative pb-8 pt-6">
        <Swiper
          modules={[Navigation, Pagination]}
          spaceBetween={16}
          slidesPerView={'auto'}
          pagination={{
            el: '.brands-swiper-pagination',
            clickable: true,
          }}
          navigation={{
            nextEl: '.brands-swiper-button-next',
            prevEl: '.brands-swiper-button-prev',
          }}
          loop={false}
        >
          {data.trendingBrands.map((brand, id) => {
            urlParams.set('brand', brand.title);

            return (
              <SwiperSlide key={id} className="w-50! h-24 shrink-0">
                <LocalizedLink
                  to={`/tooted?${urlParams.toString()}`}
                  className="flex items-center justify-center bg-rgrey-lightlight group shrink-0 relative w-50 h-24 overflow-hidden"
                  ariaLabel={brand.title}
                >
                  <img
                    className="w-24 h-8"
                    src={brand.logoUrl}
                    alt={brand.title}
                  />
                </LocalizedLink>
              </SwiperSlide>
            );
          })}
        </Swiper>
        <div className="flex justify-start items-center gap-x-4 mt-12 -ml-1">
          <button
            aria-label="eelmine"
            className="swiper-button-prev brands-swiper-button-prev"
          />
          <div className="swiper-pagination brands-swiper-pagination" />
          <button
            aria-label="järgmine"
            className="swiper-button-next brands-swiper-button-next"
          />
        </div>
      </div>
    </div>
  );
}
